import { PieChart } from '@mui/x-charts/PieChart';

export interface DashboardPieSlice {
  label: string;
  value: number;
  color?: string;
}

interface DashboardPieChartProps {
  data: DashboardPieSlice[];
  height?: number;
  valueFormatter?: (value: { value: number }) => string;
  donut?: boolean;
  /** Default keeps the legend as a column to the right of the pie. 'bottom' moves it below as a
   * row instead — used by the TV display, where charts sit in narrower columns and a right-side
   * legend can crowd or overlap the pie. */
  legendPosition?: 'right' | 'bottom';
}

export default function DashboardPieChart({ data, height = 300, valueFormatter, donut = true, legendPosition = 'right' }: DashboardPieChartProps) {
  return (
    <PieChart
      height={height}
      series={[
        {
          data: data.map((d, i) => ({ id: i, label: d.label, value: d.value, color: d.color })),
          innerRadius: donut ? '55%' : 0,
          paddingAngle: 1,
          cornerRadius: 3,
          highlightScope: { fade: 'global', highlight: 'item' },
          valueFormatter,
        },
      ]}
      slotProps={{
        legend:
          legendPosition === 'bottom'
            ? { direction: 'row', position: { vertical: 'bottom', horizontal: 'middle' } }
            : { direction: 'column', position: { vertical: 'middle', horizontal: 'right' } },
      }}
      margin={legendPosition === 'bottom' ? { top: 10, right: 10, bottom: 70, left: 10 } : { top: 10, right: 120, bottom: 10, left: 10 }}
    />
  );
}
